const LANGUAGE_KEY = "LANGUAGE_KEY"
const headerHeight = 92;
const formHeaderHeight = 317;

export {
    LANGUAGE_KEY,
    formHeaderHeight,
    headerHeight
};
